var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 67,
    viewBox: "0 0 106 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4376 66.7216H89.7373C88.8857 66.8452 88.0147 66.9091 87.1289 66.9091C86.243 66.9091 85.3721 66.8452 84.5204 66.7216H61.3731V43.323H69.7104L52.7528 23.742L35.7952 43.323H44.2071V66.7216H18.3816V66.6408C8.1875 66.3924 0 58.0508 0 47.7969C0 40.096 4.61809 33.4737 11.236 30.5483C11.1004 29.8221 11.0295 29.0732 11.0295 28.3077C11.0295 21.6074 16.4611 16.1758 23.1614 16.1758C24.0137 16.1758 24.8455 16.2637 25.6482 16.4309C31.4421 6.59794 42.1399 0 54.3787 0C71.9635 0 86.367 13.6208 87.6143 30.8875C97.3388 31.1448 105.143 39.1086 105.143 48.8951C105.143 57.7137 98.8061 65.0523 90.4376 66.6059V66.7216Z",
    fill: "#5C63AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.148e71b423927239e12d006801d5c56b.svg";
export { ForwardRef as ReactComponent };